import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow_left",
  "use": "arrow_left-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"arrow_left\"><path d=\"M23.253 24.853L13.44 16l9.707-8.747L20.8 4.906 8.747 15.999l11.947 11.2 2.56-2.347z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol